function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "1.9 2.2 76.0 75.7",
    zoomAndPan: "magnify",
    style: {
      fill: "rgb(0, 0, 0)"
    },
    original_string_length: 12579,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M60.44 66.604H62.9V69.063H60.44z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.4187,28.451c0,.552.447,1,1,1h2.69c.552,0,1-.448,1-1v-1.362h-4.69v1.362Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.4218,23.159c.6208.4931,1.2037,1.1492,1.5787,1.93h5.5262c.3749-.7808.9576-1.4369,1.579-1.93,1.762-1.399,2.916-3.636,2.916-6.173,0-4.3051-3.299-7.704-7.258-7.704s-7.258,3.399-7.258,7.704c0,2.537,1.153,4.774,2.916,6.173Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.44 72.006H62.9V74.466H60.44z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.9537,11.039c-1.147,0-2.078.93-2.078,2.078,0,1.147.931,2.077,2.078,2.077,1.148,0,2.078-.93,2.078-2.077,0-1.148-.93-2.078-2.078-2.078Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.402 72.006H71.861V74.466H69.402z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.942 66.604H67.40199999999999V69.063H64.942z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.942 72.006H67.40199999999999V74.466H64.942z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.1947,11.412c0-1.147-.93-2.078-2.078-2.078-1.147,0-2.077.931-2.077,2.078,0,1.148.93,2.078,2.077,2.078,1.148,0,2.078-.93,2.078-2.078Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.2407,31.451v.089c0,.264.214.478.478.478.275,0,.493-.232.477-.506l-.0036-.061h-.9514Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.44 61.201H62.9V63.661H60.44z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5728,28.212c-.281,0-.509.228-.509.509s.228.509.509.509.509-.228.509-.509-.228-.509-.509-.509Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.9127,11.039c-1.147,0-2.077.93-2.077,2.078,0,1.147.93,2.077,2.077,2.077,1.148,0,2.078-.93,2.078-2.077,0-1.148-.93-2.078-2.078-2.078Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.9688,25.386h-25.975c-.552,0-1,.448-1,1v5.765h26.975v-6.765Zm-22.396,5.844c-1.386,0-2.509-1.123-2.509-2.509,0-1.385,1.123-2.509,2.509-2.509s2.509,1.124,2.509,2.509c0,1.386-1.123,2.509-2.509,2.509Zm5.548,0c-1.386,0-2.509-1.123-2.509-2.509,0-1.385,1.123-2.509,2.509-2.509s2.509,1.124,2.509,2.509c0,1.386-1.123,2.509-2.509,2.509Zm5.548,0c-1.386,0-2.509-1.123-2.509-2.509,0-1.385,1.123-2.509,2.509-2.509s2.509,1.124,2.509,2.509c0,1.386-1.123,2.509-2.509,2.509Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.6687,28.212c-.281,0-.509.228-.509.509s.228.509.509.509.509-.228.509-.509-.228-.509-.509-.509Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.8417,52.912v22.917h18.222v-25.821h-15.391l-2.831,2.904Zm9.31,8.988h5.842c.553,0,1,.4481,1,1,0,.553-.447,1-1,1h-5.842c-.553,0-1-.447-1-1,0-.5519.447-1,1-1Zm-6.093-.996c-.388-.393-.384-1.027.009-1.414.393-.388,1.026-.384,1.414.009l2.699,2.736c.388.393.384,1.026-.009,1.414l-2.736,2.699c-.393.388-1.026.384-1.414-.01-.388-.393-.384-1.026.01-1.414l2.023-1.997-1.996-2.023Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.1207,28.212c-.281,0-.509.228-.509.509s.228.509.509.509.509-.228.509-.509-.228-.509-.509-.509Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.5517,53.716c-1.793-.915-2.321-3.229-1.103-4.832.773-1.016-.324-2.391-1.486-1.863-1.833.831-3.972-.199-4.465-2.151-.313-1.237-2.071-1.237-2.384,0-.493,1.952-2.632,2.982-4.465,2.151-1.162-.528-2.259.847-1.486,1.863,1.218,1.603.69,3.917-1.103,4.832-1.137.58-.746,2.294.5309,2.324,2.012.046,3.492,1.902,3.0891,3.874-.255,1.251,1.329,2.014,2.1479,1.034,1.291-1.544,3.665-1.544,4.9561,0,.818.98,2.403.217,2.1479-1.034-.403-1.972,1.077-3.828,3.0891-3.874,1.276-.03,1.668-1.744.5309-2.324Zm-8.246,4.388c-2.788,0-5.048-2.26-5.048-5.048s2.2599-5.048,5.048-5.048,5.048,2.26,5.048,5.048-2.2599,5.048-5.048,5.048Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.9688,35.595v-1.444h-26.975v13.857h2.07c1.105,0,2,.896,2,2v2.607h5.1696c.2484-.2621.5519-.4944.9174-.681.683-.348.884-1.229.42-1.8391-2.03-2.669.85-6.281,3.904-4.896.698.316,1.512-.076,1.7-.819.821-3.251,5.441-3.251,6.262,0,.188.743,1.002,1.135,1.7.819,3.054-1.385,5.934,2.227,3.904,4.896-.464.61-.263,1.491.42,1.8391.3654.1866.669.4188.9174.681h8.2396c.552,0,1-.448,1-1v-14.02h-9.649c-1.104,0-2-.896-2-2Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.3057,50.008c-1.683,0-3.048,1.365-3.048,3.048,0,1.684,1.365,3.048,3.048,3.048s3.048-1.364,3.048-3.048c0-1.683-1.365-3.048-3.048-3.048Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.9688,35.595h17.929v-13.7469h-17.929v13.7469Zm12.707-9.869c.385-.396,1.018-.405,1.414-.021l2.401,2.3329c.396.385.405,1.018.021,1.414l-2.333,2.401c-.385.3961-1.018.405-1.414.02s-.405-1.018-.021-1.414l1.636-1.683-1.683-1.636c-.396-.385-.406-1.018-.021-1.414Zm-5.805,5.635l2.254-5.985c.195-.517.7711-.778,1.288-.583.517.195.778.771.584,1.288l-2.255,5.985c-.194.517-.771.778-1.288.583-.517-.194-.778-.771-.583-1.288Zm-5.495-3.3571l2.401-2.3329c.396-.385,1.029-.375,1.414.021s.376,1.029-.02,1.414l-1.684,1.636,1.636,1.683c.385.396.376,1.029-.02,1.414-.397.385-1.03.376-1.415-.02l-2.332-2.401c-.385-.396-.376-1.029.02-1.414Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "__id0_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.5728,26.212c-1.386,0-2.509,1.124-2.509,2.509,0,1.386,1.123,2.509,2.509,2.509s2.509-1.123,2.509-2.509c0-1.385-1.123-2.509-2.509-2.509Zm0,3.018c-.281,0-.509-.228-.509-.509s.228-.509.509-.509.509.228.509.509-.228.509-.509.509Z",
    style: {
      fill: "rgb(239, 169, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id1_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.1207,26.212c-1.386,0-2.509,1.124-2.509,2.509,0,1.386,1.123,2.509,2.509,2.509s2.509-1.123,2.509-2.509c0-1.385-1.123-2.509-2.509-2.509Zm0,3.018c-.281,0-.509-.228-.509-.509s.228-.509.509-.509.509.228.509.509-.228.509-.509.509Z",
    style: {
      fill: "rgb(239, 169, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id2_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.6687,26.212c-1.386,0-2.509,1.124-2.509,2.509,0,1.386,1.123,2.509,2.509,2.509s2.509-1.123,2.509-2.509c0-1.385-1.123-2.509-2.509-2.509Zm0,3.018c-.281,0-.509-.228-.509-.509s.228-.509.509-.509.509.228.509.509-.228.509-.509.509Z",
    style: {
      fill: "rgb(239, 169, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id3_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m45.3057,48.008c-2.788,0-5.048,2.26-5.048,5.048s2.2599,5.048,5.048,5.048,5.048-2.26,5.048-5.048-2.2599-5.048-5.048-5.048Zm0,8.096c-1.683,0-3.048-1.364-3.048-3.048,0-1.683,1.365-3.048,3.048-3.048s3.048,1.365,3.048,3.048c0,1.684-1.365,3.048-3.048,3.048Z",
    style: {
      fill: "rgb(239, 169, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id4_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.0217,66.338c.388.394,1.021.398,1.414.01l2.736-2.699c.3929-.388.397-1.021.009-1.414l-2.699-2.736c-.388-.393-1.021-.397-1.414-.009-.393.387-.397,1.021-.009,1.414l1.996,2.023-2.023,1.997c-.394.388-.398,1.021-.01,1.414Z",
    style: {
      fill: "rgb(239, 169, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id5_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.1517,63.9h5.842c.553,0,1-.447,1-1,0-.5519-.447-1-1-1h-5.842c-.553,0-1,.4481-1,1,0,.553.447,1,1,1Z",
    style: {
      fill: "rgb(239, 169, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id6_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.6877,31.819c.385.396,1.018.405,1.415.02.396-.385.405-1.018.02-1.414l-1.636-1.683,1.684-1.636c.396-.385.405-1.018.02-1.414s-1.018-.406-1.414-.021l-2.401,2.3329c-.396.385-.405,1.018-.02,1.414l2.332,2.401Z",
    style: {
      fill: "rgb(239, 169, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id7_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.3797,28.776l-1.636,1.683c-.384.396-.375,1.029.021,1.414s1.029.376,1.414-.02l2.333-2.401c.384-.396.375-1.029-.021-1.414l-2.401-2.3329c-.396-.384-1.029-.375-1.414.021s-.375,1.029.021,1.414l1.683,1.636Z",
    style: {
      fill: "rgb(239, 169, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id8_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.4537,32.649c.517.195,1.094-.066,1.288-.583l2.255-5.985c.194-.517-.067-1.093-.584-1.288-.517-.1949-1.093.066-1.288.583l-2.254,5.985c-.195.517.066,1.094.583,1.288Z",
    style: {
      fill: "rgb(239, 169, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id9_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m73.9127,9.039c-2.252,0-4.077,1.826-4.077,4.078,0,.3784.0682.7377.1646,1.0853l-1.5906.8397c-.328.173-.534.514-.534.884v3.9221h-2.758v-4.4965c1.7658-.4482,3.077-2.0349,3.077-3.9396,0-2.252-1.825-4.078-4.078-4.078s-4.077,1.826-4.077,4.078c0,1.9053,1.312,3.4924,3.078,3.9401v4.496h-3.127v-3.9221c0-.371-.205-.711-.533-.884l-1.5907-.8395c.0965-.3477.1647-.707.1647-1.0855,0-2.252-1.826-4.078-4.078-4.078s-4.078,1.826-4.078,4.078,1.826,4.077,4.078,4.077c1.1519,0,2.1876-.4816,2.9293-1.2495l1.1077.5845v3.319h-3.022c-1.104,0-2,.895-2,2v1.538h-25.975c-1.657,0-3,1.343-3,3v21.622h-11.321c-.539,0-1.056.218-1.432.604l-2.831,2.904c-.364.373-.568.874-.568,1.396v22.917c0,1.105.896,2,2,2h18.222c1.105,0,2-.895,2-2v-21.214h4.3311c-.0804,1.6675,1.0952,3.3768,3.1499,3.424.766.018,1.329.724,1.176,1.475-.671,3.286,3.491,5.29,5.642,2.717.491-.588,1.395-.588,1.886,0,2.151,2.573,6.313.569,5.642-2.717-.153-.751.41-1.457,1.176-1.475,2.0547-.0472,3.2303-1.7565,3.1499-3.424h7.4011c1.657,0,3-1.343,3-3v-14.02h6.28c1.105,0,2-.896,2-2v-13.7469c0-1.105-.895-2-2-2h-3.022v-3.319l1.1083-.5844c.7414.7678,1.7769,1.2493,2.9286,1.2493,2.253,0,4.078-1.825,4.078-4.077s-1.825-4.078-4.078-4.078Zm-19.959,6.155c-1.147,0-2.078-.93-2.078-2.077,0-1.148.931-2.078,2.078-2.078,1.148,0,2.078.93,2.078,2.078,0,1.147-.93,2.077-2.078,2.077Zm8.086-3.782c0-1.147.93-2.078,2.077-2.078,1.148,0,2.078.931,2.078,2.078,0,1.148-.93,2.078-2.078,2.078-1.147,0-2.077-.93-2.077-2.078Zm-36.046,14.974c0-.552.448-1,1-1h25.975v6.765h-26.975v-5.765Zm2.07,49.443H9.8417v-22.917l2.831-2.904h15.391v25.821Zm24.957-19.789c-2.012.046-3.492,1.902-3.0891,3.874.255,1.251-1.33,2.014-2.1479,1.034-1.291-1.544-3.665-1.544-4.9561,0-.819.98-2.403.217-2.1479-1.034.403-1.972-1.077-3.828-3.0891-3.874-1.277-.03-1.668-1.744-.5309-2.324,1.793-.915,2.321-3.229,1.103-4.832-.773-1.016.324-2.391,1.486-1.863,1.833.831,3.972-.199,4.465-2.151.313-1.237,2.071-1.237,2.384,0,.493,1.952,2.632,2.982,4.465,2.151,1.162-.528,2.259.847,1.486,1.863-1.218,1.603-.69,3.917,1.103,4.832,1.137.58.7451,2.294-.5309,2.324Zm11.597-4.425c0,.552-.448,1-1,1h-8.2396c-.2484-.2621-.5519-.4944-.9174-.681-.683-.348-.884-1.229-.42-1.8391,2.03-2.669-.85-6.281-3.904-4.896-.698.316-1.512-.076-1.7-.819-.821-3.251-5.441-3.251-6.262,0-.188.743-1.002,1.135-1.7.819-3.054-1.385-5.934,2.227-3.904,4.896.464.61.263,1.491-.42,1.8391-.3654.1866-.669.4188-.9174.681h-5.1696v-2.607c0-1.104-.895-2-2-2h-2.07v-13.857h26.975v1.444c0,1.104.896,2,2,2h9.649v14.02Zm8.28-29.767v13.7469h-17.929v-13.7469h17.929Zm1.015-6.6541c-1.147,0-2.077-.93-2.077-2.077,0-1.148.93-2.078,2.077-2.078,1.148,0,2.078.93,2.078,2.078,0,1.147-.93,2.077-2.078,2.077Z",
    style: {
      fill: "rgb(239, 169, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id10_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.5507,5.593l-1.643,2.17c-.334.44-.247,1.067.193,1.4.441.334,1.068.247,1.401-.193l1.643-2.169c.333-.4399.247-1.068-.193-1.401-.441-.334-1.068-.2469-1.401.1931Z",
    style: {
      fill: "rgb(239, 169, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id11_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.1777,24.725c.779.618,1.241,1.383,1.241,2.13v1.596c0,1.2386.751,2.3008,1.822,2.7587v.3303c0,1.368,1.109,2.478,2.478,2.478,1.426,0,2.5569-1.201,2.473-2.624l-.0088-.1497c1.1246-.4329,1.9258-1.5162,1.9258-2.7933v-1.596c0-.747.462-1.512,1.241-2.13,2.238-1.777,3.672-4.59,3.672-7.739,0-5.309-4.096-9.704-9.258-9.704s-9.258,4.395-9.258,9.704c0,3.149,1.433,5.962,3.672,7.739Zm5.541,7.293c-.264,0-.478-.214-.478-.478v-.089h.9514l.0036.061c.016.274-.202.506-.477.506Zm2.39-3.567c0,.552-.448,1-1,1h-2.69c-.553,0-1-.448-1-1v-1.362h4.69v1.362Zm-2.345-19.169c3.959,0,7.258,3.399,7.258,7.704,0,2.537-1.154,4.774-2.916,6.173-.6214.4931-1.2042,1.1492-1.579,1.93h-5.5262c-.3751-.7808-.9579-1.4369-1.5787-1.93-1.763-1.399-2.916-3.636-2.916-6.173,0-4.3051,3.298-7.704,7.258-7.704Z",
    style: {
      fill: "rgb(239, 169, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id12_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.7637,3.171v2.7209c0,.552.447,1,1,1,.552,0,1-.448,1-1v-2.7209c0-.553-.448-1-1-1-.553,0-1,.447-1,1Z",
    style: {
      fill: "rgb(239, 169, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id13_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.6397,5.316c-.44.333-.526.961-.193,1.401l1.643,2.169c.333.44.96.527,1.401.193.44-.333.527-.96.193-1.4l-1.643-2.17c-.333-.44-.96-.526-1.401-.193Z",
    style: {
      fill: "rgb(239, 169, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id14_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.6497,13.805c-.548.068-.938.567-.871,1.115.067.548.566.938,1.114.871l2.701-.332c.548-.067.938-.566.871-1.114-.067-.548-.566-.938-1.114-.871l-2.701.331Z",
    style: {
      fill: "rgb(239, 169, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id15_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.8327,13.64l-2.701-.331c-.548-.0681-1.047.322-1.115.87-.067.549.323,1.048.871,1.115l2.701.331c.548.067,1.047-.323,1.114-.871.0681-.548-.322-1.047-.87-1.114Z",
    style: {
      fill: "rgb(239, 169, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id16_sn7p50abis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.8607,70.006h-2.459c-.0893,0-.1745.015-.2607.0263.1611-.2882.2607-.6155.2607-.9693v-2.459c0-1.105-.896-2-2-2h-2.46c-.1045,0-.205.0153-.3052.0308.1626-.2892.2632-.6182.2632-.9738v-2.46c0-1.104-.896-2-2-2h-2.46c-1.105,0-2,.896-2,2v2.46c0,.5848.255,1.1059.6548,1.4715-.3998.3656-.6548.8867-.6548,1.4715v2.459c0,.5849.2551,1.1061.6551,1.4717-.4.3658-.6551.8869-.6551,1.4713v2.46c0,1.105.895,2,2,2h2.46c.3746,0,.7212-.1095,1.021-.2888.2998.1793.6464.2888,1.021.2888h2.46c.366,0,.7046-.1055.9998-.2773.2952.1718.6339.2773,1.0002.2773h2.459c1.105,0,2-.895,2-2v-2.46c0-1.104-.895-2-2-2Zm-8.961,4.46h-2.46v-2.46h2.46v2.46Zm0-5.403h-2.46v-2.459h2.46v2.459Zm0-5.402h-2.46v-2.46h2.46v2.46Zm4.502,10.805h-2.46v-2.46h2.46v2.46Zm0-5.403h-2.46v-2.459h2.46v2.459Zm4.459,5.403h-2.459v-2.46h2.459v2.46Z",
    style: {
      fill: "rgb(239, 169, 107)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5);
export default __webpack_public_path__ + "static/media/step5.ed6d9b900b3666e8f746e9701a035917.svg";
export { ForwardRef as ReactComponent };